import React from 'react';

export default function FormattedDate({ date, customFormat }) {
    if (!date) return null;

    const dateObj = new Date(date);

    let options;
    if (!customFormat) {
        // Si aucun format personnalisé n'est précisé, on affiche tout
        options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };
    } else {
        // Si un format personnalisé est précisé, on l’utilise
        options = {};
        if (customFormat.includes('day')) options.day = '2-digit';
        if (customFormat.includes('month')) options.month = 'long';
        if (customFormat.includes('year')) options.year = 'numeric';
        if (customFormat.includes('hour')) options.hour = '2-digit';
        if (customFormat.includes('minute')) options.minute = '2-digit';
    }

    const formattedDate = new Intl.DateTimeFormat('fr-FR', options).format(dateObj);

    return <span>{formattedDate.replace(',', ' .')}</span>;
}
